/**
 * Animation Class
 */
const animation = {

	// Variables
	animationClass: 'animate-',
    inViewClass: 'visible',
    parallaxClass: 'parallax',
    lastScrollTop: 0,
    scrollDirection: 'down',

	// Initialize
	init: function() {

        // Record current scroll position
        this.lastScrollTop = $(window).scrollTop()

		// Bind to window scroll
        const that = this
		$(window).on('scroll', function() {

            // Check scroll direction
            const scrollTop = $(this).scrollTop()
            if (scrollTop > that.lastScrollTop) that.scrollDirection = 'up'
            else that.scrollDirection = 'down'

            // Animate elements if in view
            const elems = $('[class*="'+that.animationClass+'"]:not(.'+that.inViewClass+')')
			elems.each(function() {
				const elem = $(this)

				if (that.isInView(elem[0])) {
                    elem.addClass('visible')
				}
			})

            // Parallax elements
            const parallaxes = $('[class*="'+that.parallaxClass+'"][data-rate]')
			parallaxes.each(function() {
                const elem = $(this)
                const rate = elem[0].dataset.rate
				const pos = window.scrollY - (window.scrollY * rate)
                elem[0].style.transform = 'translate3d(0, '+pos+'px, 0)'
			})
		}.bind(that))

        // Trigger scroll event
        $(window).trigger('scroll')
	},

    /**
     * Check if an element is in viewport
     */
    isInView: function(element) {
        const rect = element.getBoundingClientRect()
        const height = (window.innerHeight || document.documentElement.clientHeight)
        const offset = 100
        const bottom = height - offset
        const top = 0 + offset

        if (rect.top <= bottom) {
            if (rect.top >= top) return true
            else {
                if (rect.bottom >= top) return true
                else return false
            }
        }
        else return false
    },

}

$(() => {
    window.animation = animation
    window.animation.init()
})